module.exports = __webpack_public_path__ + "static/img/84-2.5166487.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/84-2.jpg
// module id = bf3d
// module chunks = 0